export default __webpack_public_path__ + "static/prices-b9e19cbcd9687f90066b6955e8b9c259.png";